import { PackageMeta } from '../PackageMeta';
import { z } from 'zod';

export const SourceDataBody = z
  .object({
    helpTextSource: z.string().trim().optional(),
    hooksSource: z.string().trim().optional(),
    migrationSource: z.string().trim().optional(),
    logicSource: z.string().trim().optional(),
    invalidData: z.any().optional(),
    rootInputSettings: z.any().optional(),
    rootInputUrn: z.any().optional(),
    // TODO: use packageMeta instead
    stepDetails: z.any().optional().describe('Deprecated'),
    stepPackages: z.any().optional(),
  })
  .or(z.any())
  .optional();

export const SourceMetaMocksBody = z
  .object({
    mocks: z.any().optional(),
  })
  .or(z.any())
  .optional();

export const SourceMetaLabelBody = z
  .object({
    label: z.string().trim().nonempty(),
  })
  .or(z.any())
  .optional();

export const CreateSourceBody = z.object({
  id: z.string().trim().optional(),
  meta: SourceMetaLabelBody,
  source: z.object({
    data: SourceDataBody,
    meta: z.intersection(SourceMetaMocksBody, SourceMetaLabelBody),
    packageMeta: PackageMeta,
  }),
});

export const SetPublishedBody = z.object({
  version: z.string().trim(),
});

export const CreateSourceSourceRevisionBody = z.intersection(
  z.intersection(
    z.object({
      data: SourceDataBody,
    }),
    z.object({
      meta: SourceMetaMocksBody,
    }),
  ),
  z.object({
    packageMeta: PackageMeta,
  }),
);

export const ForkSourceBranchBody = z
  .object({
    meta: z.intersection(SourceMetaMocksBody, SourceMetaLabelBody).optional(),
    label: z.string().trim().optional(),
  })
  .transform((data) => {
    return {
      ...data,
      label: data?.label || data?.meta?.label,
    };
  });

export const UpdateMetaBranchBodyLegacy = z
  .object({
    sourceMembers: z
      .object({
        accountId: z.array(z.string().trim()).optional(),
        userId: z.array(z.string().trim()).optional(),
      })
      .optional(),
    meta: z
      .intersection(
        SourceMetaLabelBody,
        z.object({
          shared: z
            .object({
              currentAccount: z.boolean().optional(),
            })
            .optional(),
        }),
      )
      .optional(),
    label: z.string().trim().optional(),
  })
  .transform((data) => {
    return {
      ...data,
      label: data?.label || data?.meta?.label,
    };
  });
